import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(protected)/orgs')({
  component: OrganizationsLayout,
});

function OrganizationsLayout() {
  return (
    <div className="mx-6 my-2 flex">
      <Outlet />
    </div>
  );
} 